module.exports = __webpack_public_path__ + "img/OFW.4657ea3e.png";